import { camelCase } from '../util.js'
const works = [
  {
    title: '普及金融知识 守住‘钱袋子’',
    desc: '普及金融知识 守住‘钱袋子’',
    thumb: camelCase('cases-brand-avic-0'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-01'),
      camelCase('cases-brand-avic-lazyload-02'),
      camelCase('cases-brand-avic-lazyload-03')
    ]
  },
  {
    title: '博学更称心',
    desc: '博学更称心',
    thumb: camelCase('cases-brand-avic-1'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-11'),
      camelCase('cases-brand-avic-lazyload-12'),
      camelCase('cases-brand-avic-lazyload-13'),
      camelCase('cases-brand-avic-lazyload-14'),
      camelCase('cases-brand-avic-lazyload-15'),
      camelCase('cases-brand-avic-lazyload-16'),
      camelCase('cases-brand-avic-lazyload-17'),
      camelCase('cases-brand-avic-lazyload-18')
    ]
  },
  {
    title: '成都善行者公益徒步活动',
    desc: '成都善行者公益徒步活动',
    thumb: camelCase('cases-brand-avic-2'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-21'),
      camelCase('cases-brand-avic-lazyload-22'),
      camelCase('cases-brand-avic-lazyload-23')
    ]
  },
  {
    title: '信约天下 专善所托',
    desc: '信约天下 专善所托',
    thumb: camelCase('cases-brand-avic-3'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-31'),
      camelCase('cases-brand-avic-lazyload-32'),
      camelCase('cases-brand-avic-lazyload-33'),
      camelCase('cases-brand-avic-lazyload-34'),
      camelCase('cases-brand-avic-lazyload-35'),
      camelCase('cases-brand-avic-lazyload-36'),
      camelCase('cases-brand-avic-lazyload-37'),
      camelCase('cases-brand-avic-lazyload-38'),
      camelCase('cases-brand-avic-lazyload-39'),
      camelCase('cases-brand-avic-lazyload-310'),
      camelCase('cases-brand-avic-lazyload-311'),
      camelCase('cases-brand-avic-lazyload-312'),
      camelCase('cases-brand-avic-lazyload-313'),
      camelCase('cases-brand-avic-lazyload-314'),
      camelCase('cases-brand-avic-lazyload-315'),
      camelCase('cases-brand-avic-lazyload-316'),
      camelCase('cases-brand-avic-lazyload-317'),
      camelCase('cases-brand-avic-lazyload-318'),
      camelCase('cases-brand-avic-lazyload-319'),
      camelCase('cases-brand-avic-lazyload-320'),
      camelCase('cases-brand-avic-lazyload-321'),
      camelCase('cases-brand-avic-lazyload-322'),
      camelCase('cases-brand-avic-lazyload-323'),
      camelCase('cases-brand-avic-lazyload-324'),
      camelCase('cases-brand-avic-lazyload-325')
    ]
  },
  {
    title: '杂志雕塑篇制作',
    desc: '杂志雕塑篇制作',
    thumb: camelCase('cases-brand-avic-4'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-41')
    ]
  },
  {
    title: '信约天下 专善所托',
    desc: '信约天下 专善所托',
    thumb: camelCase('cases-brand-avic-5'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-51')
    ]
  },
  {
    title: '六十八载 振翅苍穹 百年复兴 筑梦航空',
    desc: '六十八载 振翅苍穹 百年复兴 筑梦航空',
    thumb: camelCase('cases-brand-avic-6'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-61')
    ]
  },
  {
    title: '信约天下 专善所托',
    desc: '信约天下 专善所托',
    thumb: camelCase('cases-brand-avic-7'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-71')
    ]
  },
  {
    title: '世界防治荒漠化和干旱日',
    desc: '世界防治荒漠化和干旱日',
    thumb: camelCase('cases-brand-avic-8'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-81')
    ]
  },
  {
    title: '善待资源环境 共创美丽地球',
    desc: '善待资源环境 共创美丽地球',
    thumb: camelCase('cases-brand-avic-9'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-91')
    ]
  },
  {
    title: '全民健身日',
    desc: '全民健身日',
    thumb: camelCase('cases-brand-avic-10'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-101')
    ]
  },
  {
    title: '九载磨砺 初心如一',
    desc: '九载磨砺 初心如一',
    thumb: camelCase('cases-brand-avic-11'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-111')
    ]
  },
  {
    title: '行稳 致远',
    desc: '中航信托，不辜负每一份信任',
    thumb: camelCase('cases-brand-avic-12'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-121')
    ]
  },
  {
    title: '共同信约',
    desc: '中航信托企业文化手册',
    thumb: camelCase('cases-brand-avic-13'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-131'),
      camelCase('cases-brand-avic-lazyload-132'),
      camelCase('cases-brand-avic-lazyload-133'),
      camelCase('cases-brand-avic-lazyload-134'),
      camelCase('cases-brand-avic-lazyload-135'),
      camelCase('cases-brand-avic-lazyload-136'),
      camelCase('cases-brand-avic-lazyload-137'),
      camelCase('cases-brand-avic-lazyload-138'),
      camelCase('cases-brand-avic-lazyload-139'),
      camelCase('cases-brand-avic-lazyload-1310'),
      camelCase('cases-brand-avic-lazyload-1311'),
      camelCase('cases-brand-avic-lazyload-1312'),
      camelCase('cases-brand-avic-lazyload-1313'),
      camelCase('cases-brand-avic-lazyload-1314'),
      camelCase('cases-brand-avic-lazyload-1315'),
      camelCase('cases-brand-avic-lazyload-1316'),
      camelCase('cases-brand-avic-lazyload-1317'),
      camelCase('cases-brand-avic-lazyload-1318'),
      camelCase('cases-brand-avic-lazyload-1319'),
      camelCase('cases-brand-avic-lazyload-1320'),
      camelCase('cases-brand-avic-lazyload-1321'),
      camelCase('cases-brand-avic-lazyload-1322'),
      camelCase('cases-brand-avic-lazyload-1323'),
      camelCase('cases-brand-avic-lazyload-1324'),
      camelCase('cases-brand-avic-lazyload-1325'),
      camelCase('cases-brand-avic-lazyload-1326'),
      camelCase('cases-brand-avic-lazyload-1327'),
      camelCase('cases-brand-avic-lazyload-1328'),
      camelCase('cases-brand-avic-lazyload-1329'),
      camelCase('cases-brand-avic-lazyload-1330')
    ]
  },
  {
    title: '中航信托-论坛官方APP宣传广告',
    desc: '中航信托-论坛官方APP宣传广告',
    thumb: camelCase('cases-brand-avic-14'),
    zpic: [
      camelCase('cases-brand-avic-lazyload-141')
    ]
  },
  {
    title: '从前慢',
    desc: '从前慢',
    thumb: camelCase('cases-brand-avic-15'),
    zpic: [
      require('../../assets/cases-brand-avic-lazyload-151.mp4')
    ]
  },
  {
    title: '中航信托',
    desc: '中航信托',
    thumb: camelCase('cases-brand-avic-16'),
    zpic: [
      require('../../assets/cases-brand-avic-lazyload-161.mp4')
    ]
  }
]

export default {
  name: '中航信托',
  logo: {
    default: camelCase('cases-brand-19'),
    active: camelCase('cases-brand-19-cover')
  },
  works
}
